/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
    $('select').niceSelect();

    wow = new WOW();
    wow.init();
});




